export const UPDATE_USER = 'UPDATE_USER';
export const CLEAR_USER = 'CLEAR_USER';

/**
 * @param {String} language
 * @return {Object}
 */
export function updateUser(user) {
  return {
    type: UPDATE_USER,
    user,
  };
}

export function clearUser() {
  return {
    type: CLEAR_USER,
  };
}
